function openSubscriptionModal() {
    document.getElementById('subscriptionModal').style.display = 'flex';
    document.body.style.overflow = 'hidden';
}

function closeSubscriptionModal() {
    document.getElementById('subscriptionModal').style.display = 'none';
    document.body.style.overflow = 'auto';
}

// Close modal when clicking outside
document.addEventListener('click', function(event) {
    const modal = document.getElementById('subscriptionModal');
    if (event.target === modal) {
        closeSubscriptionModal();
    }
});

// Close modal with Escape key
document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
        closeSubscriptionModal();
    }
});

// Function to handle product button clicks with custom URLs
function handleProductButtonClick(url) {
    if (url) {
        window.open(url, '_blank');
    }
}
